import React, { useCallback, useEffect, useState } from 'react';

import { useNotices } from 'hooks';

import { Container } from './styles';

interface IItemCounterProps {
  quantityMax?: number;
  quantityMin?: number;
  quantity?: number;
  setQuantity(quantity: number): void;
  handleIncrementItem?(): void;
  handleDecrementItem?(): void;
  showIcon?: boolean;
  readOnly?: boolean;
  onChange?(state: number): void;
}

const ItemCounter: React.FC<IItemCounterProps> = ({
  quantityMax,
  quantityMin,
  quantity,
  setQuantity,
  handleIncrementItem,
  handleDecrementItem,
  showIcon = false,
  readOnly = false,
  onChange = () => {},
}) => {
  const { addNotices } = useNotices();

  const handleChangeQuantity = useCallback(
    (type: string) => {
      const newQuantity = type === 'minus' ? quantity - 1 : quantity + 1;

      setQuantity(newQuantity);
    },
    [quantity],
  );

  const handleSetQuantity = useCallback(
    (quantityItens: number) => {
      if (Number.isNaN(Number(quantityItens))) {
        addNotices({
          messages: ['Informe um número válido'],
          type: 'allMessages',
        });
      } else {
        setQuantity(Number(quantityItens));
      }
    },
    [addNotices],
  );

  const handleInputBlur = useCallback(() => {
    if (onChange) onChange(quantity);
  }, [onChange, quantity]);

  return (
    <Container className="item-counter">
      <button
        type="button"
        disabled={
          quantity === 0
          // handleDecrementItem
          //   ? showIcon
          //     ? quantity === 0
          //     : false
          //   : quantity <= quantityMin
        }
        onClick={() => {
          if (handleDecrementItem) {
            // if (showIcon ? quantity > 0 : quantity > 1)
            //   handleChangeQuantity('minus');
            handleChangeQuantity('minus');
            handleDecrementItem();
          } else handleChangeQuantity('minus');
        }}
      >
        -
      </button>
      {showIcon && quantity === 0 ? (
        <span className="icon-shopping-input">
          <img
            src="/images/icons/basket-black.svg"
            alt="Cesta"
            className="icon shopping-icon"
          />
        </span>
      ) : (
        <div className="input-wrapper">
          {quantity === 0 ? (
            <span className="fake-value">1</span>
          ) : (
            <input
              type="text"
              value={quantity}
              onChange={e => handleSetQuantity(Number(e.target.value))}
              readOnly={showIcon || readOnly}
              onBlur={handleInputBlur}
            />
          )}
        </div>
      )}
      <button
        type="button"
        disabled={!!quantityMax && quantity >= quantityMax}
        onClick={() => {
          handleChangeQuantity('plus');
          if (handleIncrementItem) handleIncrementItem();
        }}
      >
        +
      </button>
    </Container>
  );
};

export default ItemCounter;
